import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface ICommentDetail {
    id: string
    user_id: string
    parent_id: string
    content?: string
    likes_count: number
    comments_count: number
    created_at: number
}

export const getCommentDetail = async (id: string): Promise<ApiRes<ICommentDetail>> => {
    return await apiGet(API_URL, `admin/comment/${id}`)
}
